export default "__VITE_ASSET__pY$8NXR2__"